<template>
  <div :id="id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="BlogAuthorCardComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

      <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-BlogAuthorCardComponent'>
        <img src="static/images/icons/engrenagem.svg"
             class="svg-icon normal-action"
             @click="openPopupChoose"/>
      </options-element-bar>

        <div v-if="internal_config.authorID != 0"  style="height: 100%">
          <figure v-for="author in internal_config.authors" :key="author.slug" class="snip1578" :style="{ 'background-color' : internal_config.backgroundColor }">
            <figcaption>
              <h3 class="clean-text-css" :style="titleStyle()">{{ author.name }}</h3>
              <span :style="subTitleStyle()">{{ author.signature }}</span>
              <div class="icons">
                <a  href="#" :style="{color: internal_config.emailColorIcon}" ><i class="fa fa-envelope"></i></a>
                <a v-if="author.facebook_url" :style="{color: internal_config.facebookColorIcon}" ><i class="fab fa-facebook-f"></i></a>
                <a v-if="author.twitter_url" :style="{color: internal_config.twitterColorIcon}"> <i class="fab fa-twitter"></i></a>
                <a v-if="author.instagram_url" :style="{color: internal_config.instagramColorIcon}"><i class="fab fa-instagram"></i></a>
                <a v-if="author.linkedin_url" :style="{color: internal_config.linkedinColorIcon}"><i class="fab fa-linkedin-in"></i></a>
                <a v-if="author.youtube_url" :style="{color: internal_config.youtubeColorIcon}"><i class="fab fa-youtube"></i></a>
                <a v-if="author.medium_url" :style="{color: internal_config.mediumColorIcon}"><i class="fab fa-medium-m"></i></a>
              </div>
            </figcaption>
            <img :src="author.thumbnail"  alt="profile-sample6" />

          </figure>
        </div>
        <div v-else>
          <div style="background-color: white; height: 100px; width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column">
            <h6 class="text-center">{{ $t('ct-blog-no-authors-on-blog') }}</h6>
            <span>{{ $t('ct-blog-add_author') }}</span>
          </div>
        </div>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import elementData from './Model';
import OptionsElementBar from '../../OptionsElementBar';
import Resources from './Resources.vue';
import { getAuthor } from '../../../../../js/services/editor/blog.js';

export default {
  name: 'BlogAuthorCardComponent',
  props: ['config', 'id'],
  components: { OptionsElementBar, Resources },
  data() {
    return elementData.data();
  },
  methods: {
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    onResize: function(x, y, width, height) {
      // eslint-disable-next-line no-unused-expressions
      (width < 230) ? width = 230 : '';
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },
    build(config) {
      this.internal_config = {...this.internal_config, ...config};
    },
    animation() {
      return false;
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    style() {
      return `width: ${this.internal_config.width};
               height:  ${this.internal_config.height};
               z-index: ${this.internal_config.zIndex};
               margin: 0 auto;
               padding-top: ${this.internal_config.paddingTop};
               padding-left: ${this.internal_config.paddingLeft};
               padding-right: ${this.internal_config.paddingRight};
               padding-bottom: ${this.internal_config.paddingBottom};
               left:  ${this.internal_config.left};
               top: ${this.internal_config.top}`;
    },
    titleStyle() {
      return `font-family:  ${this.internal_config.titleStyle.family};
                  font-size: ${this.internal_config.titleStyle.size};
                  text-align: ${this.internal_config.titleStyle.align};
                  font-weight: ${this.internal_config.titleStyle.weight};
                  font-style: ${this.internal_config.titleStyle.style};
                  text-decoration: ${this.internal_config.titleStyle.stroke};
                  color: ${this.internal_config.titleStyle.color}`;
    },
    subTitleStyle() {
      return `font-family:  ${this.internal_config.subTitleStyle.family};
                  font-size: ${this.internal_config.subTitleStyle.size};
                  text-align: ${this.internal_config.subTitleStyle.align};
                  font-weight: ${this.internal_config.subTitleStyle.weight};
                  font-style: ${this.internal_config.subTitleStyle.style};
                  text-decoration: ${this.internal_config.subTitleStyle.stroke};
                  color: ${this.internal_config.subTitleStyle.color}`;
    },
    getContent() {
      getAuthor(this.internal_config.authorID)
        .then(({ data }) => {
          if (data !== 'not-found') {
            this.internal_config.authors = [ data ];
            this.internal_config.authorID = data.cryptID;
          } else {
            this.internal_config.authorID = 0;
          }
        });
    },
    callbackConfig(value) {
      if (value.type === 'author') {
        this.internal_config.authorID = value.value;
        this.getContent();
      }
      if (value.type === 'colors') {
        this.internal_config.emailColorIcon = '#363636';
        this.internal_config.facebookColorIcon = '#1877f2';
        this.internal_config.instagramColorIcon = '#d00174';
        this.internal_config.twitterColorIcon = '#1da1f2';
        this.internal_config.linkedinColorIcon = '#2867b2';
        this.internal_config.youtubeColorIcon = '#ff0000';
        this.internal_config.mediumColorIcon = '#12100e';
      }
    },
    openPopupChoose() {
      this.$root.$emit('openBlogSettingsModal', this.internal_config, this.$options.name, this.callbackConfig);
    }
  },
  mounted() {
    this.build(this.$props.config);
    this.$refs.resourcesData.setValuesData(this);

    document.documentElement.style.setProperty('--card-author-icon-hover', this.internal_config.iconHoverColor);
    this.internal_config.authors = [];
    this.getContent();
  },
  computed: {
    colorHover() {
      document.documentElement.style.setProperty('--BlogAuthorCardComponent-icon-hover', this.internal_config.iconHoverColor);
      return 0;
    }
  }
};
</script>

<style>
  [element="BlogAuthorCardComponent"] .vdr {
    /*height: auto !important;*/
    min-width: 250px !important;
  }
</style>

<style scoped>

  @import url(https://fonts.googleapis.com/css?family=Open+Sans);
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css);
  .snip1578 {
    font-family: 'Open Sans', Arial, sans-serif;
    position: relative;
    display: inline-block;
    margin: 10px;
    min-width: 230px;
    max-width: 90%;
    width: 100%;
    color: #000;
    text-align: left;
    font-size: 16px;
    background: #fff;
    border-radius: 5px;
    height: 90%;
    display: flex;
    justify-content: space-between;

  }

  .snip1578 *,
  .snip1578:before,
  .snip1578:after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }



  .snip1578 figcaption {
    position: relative;
    top: 0;
    right: 40%;
    left: 0;
    bottom: 0;
    padding: 15px;
  }

  .snip1578 img {
    max-width: 35%;
    margin-top: -15px;
    margin-right: 15px;
    /*margin-left: 60%;*/
    margin-bottom: 15px;
    backface-visibility: hidden;
    vertical-align: top;
    border-radius: 5px;
  }

  .snip1578 h3 {
    margin: 0;
    font-size: 1.1em;
    font-weight: normal;
  }

  .snip1578 .icons {
    font-size: 1.6rem;
  }

  .snip1578 .icons a {
    color: #ccc;
  }


</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/AuthorCard/Card.vue